import styled from "styled-components";

export const ProjectsContainer = styled.div`
	padding-top: 180px;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
	z-index: "-99999";
`;
